module.exports = __webpack_public_path__ + "static/media/SharedBlue.b74e49fb.svg";